import * as _ from 'lodash';
var transformJSONKeyFactory = function (tranformMethod) {
    var transformHelper = function (json) {
        var transformedObject = {};
        var transformedArray = [];
        if (!_.isObject(json)) {
            return json;
        }
        _.forOwn(json, function (value, key) {
            var camelKey = tranformMethod(key);
            if (_.isPlainObject(value) || _.isArray(value)) {
                value = transformHelper(value); // eslint-disable-line no-param-reassign
            }
            if (_.isArray(json)) {
                transformedArray.push(value);
            }
            else {
                transformedObject[camelKey] = value;
            }
        });
        if (_.isArray(json)) {
            return transformedArray;
        }
        return transformedObject;
    };
    return function (json) {
        return transformHelper(json);
    };
};
/**
 * This method transforms the JSON's keys to camel case
 * and any object within an array's keys to camel case as well.
 **/
export var camelizeJSON = transformJSONKeyFactory(_.camelCase);
/**
 * This method transforms the JSON's keys to snake case
 * and any object within an array's keys to snake case as well.
 **/
export var snakeCaseJSON = transformJSONKeyFactory(_.snakeCase);
